import script from "./fw17_sample_articles.vue?vue&type=script&setup=true&lang=js"
export * from "./fw17_sample_articles.vue?vue&type=script&setup=true&lang=js"

import "./fw17_sample_articles.vue?vue&type=style&index=0&id=dbda6238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbda6238"]])

export default __exports__